export default __webpack_public_path__ + "static/media/fruit.c0f55fd3.jpeg";